/**
 * The Growth Strategist ledger's default columns and the labels the GS role
 * reads Flow's account columns under.
 *
 * The Columns chooser offers a GS every `ACCOUNT_FIELDS` entry, as it does
 * for every role. This file only relabels: the overrides below replace four
 * catalog labels for the GS role, and every other column keeps its
 * `ACCOUNT_FIELDS` label.
 *
 * Keys are Flow's account field keys, not the parked ledger's names. The
 * parked ledger's `arr` is Flow's own `arr` (active subscriptions), not
 * `gs_arr`.
 */

/**
 * The columns a GS preset shows, in order. `name` leads, as in every account
 * view. The first six are the parked ledger's default set. Next GS and Next GS
 * Date follow ARR.
 */
export const GS_LEDGER_DEFAULT_COLUMN_KEYS = [
  'name',
  'health',
  'credit_pace',
  'credits_l30',
  'contract_end',
  'arr',
  'next_gs',
  'next_gs_assign_date',
] as const;

/**
 * The GS labels that differ from the catalog's, keyed by Flow key. Each is
 * the parked ledger's name. Neither ARR column is relabeled: Flow's `arr`
 * reads "ARR" and `gs_arr` reads "Contracted ARR". Applied to column labels
 * only, never to keys.
 */
export const GS_LEDGER_COLUMN_LABELS: Readonly<Record<string, string>> = {
  name: 'Account',
  credit_pace: 'Credit Pace',
  claydr_name: 'Clay DR',
  last_claydr_meeting: 'Last Clay DR Meeting',
};
